export var Status;
(function (Status) {
    Status[Status["Critical"] = 0] = "Critical";
    Status[Status["Alarm"] = 1] = "Alarm";
    Status[Status["NotReporting"] = 2] = "NotReporting";
    Status[Status["OK"] = 3] = "OK";
})(Status || (Status = {}));
